import { isError } from "../errors/is-error.js";
/**
 * Returns the value of a result or throws an error if the result is an error.
 *
 * This is used to extract the value of a result when you know it is not an error but
 * TypeScript cannot infer it.
 *
 * It's always better to use the result directly and handle the error case, but this is
 * relatively safe to use when receiving a Result with 'never' as the error type.
 */
export async function runUnsafe(result) {
    const value = await result;
    if (isError(value)) {
        throw value;
    }
    return value;
}
